import { CircularProgress } from '@material-ui/core';
import { Html } from '@react-three/drei';
import CustomText from 'components/common/text/CustomText';
import { TInputState } from 'lib/types/common';
import React, { useEffect } from 'react';
import styled from 'styled-components';

interface ModelFallbackProps {
  isEnd: TInputState<boolean>;
  onLoading?: (isLoading: boolean) => void;
}

export default function ModelFallback({ isEnd, onLoading }: ModelFallbackProps) {
  useEffect(() => {
    if (!onLoading) return;

    onLoading(true);

    return () => {
      isEnd.setValue(true);
      onLoading(false);
    };
  }, []);

  return (
    <Html center>
      <StyledModelFallback>
        <CustomText
          fontSize={14}
          fontWeight={400}
          // fontColor={_color.contentQuaternary}
        >
          Loading...
        </CustomText>
        <CircularProgress />
      </StyledModelFallback>
    </Html>
  );
}

const StyledModelFallback = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  row-gap: 10px;
`;
